import { createAsyncThunk } from "@reduxjs/toolkit";
import {  get } from "../../api/api";
import { setLoading } from "../../app/loadingSlice";

//Fetch ministries master list
export const fetchMinistriesMenu = createAsyncThunk("nodemenu", async (_, { dispatch }) => {
    dispatch(setLoading(true));
    
    try {
        const response = await get("/nodemenu")
        return response;
    } catch (error) {
        dispatch(setLoading(true));
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Fetch ministries master list
export const fetchIndicatorsMenu = createAsyncThunk("indicatormenu/id", async (indicatorId: number, { dispatch }) => {
    dispatch(setLoading(true));    
    try {
        const response = await get(`/indicatormenu/${indicatorId}`)
        return response;
    }
    catch (error) {
        dispatch(setLoading(false));    
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});

export const fetchReportsMenu = createAsyncThunk("reportmenu/id", async (indicatorId: number, { dispatch }) => {
    dispatch(setLoading(true));    
    try {
        const response = await get(`/reportmenu/${indicatorId}`)
        return response;
    }
    catch (error) {
        dispatch(setLoading(false));    
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});